interface ErrorCorrectionPercents {
  [key: string]: number;
}

export default {
  L: 0.07,
  M: 0.15,
  Q: 0.25,
  H: 0.3
} as ErrorCorrectionPercents;
